import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../../components";
import { useAuth } from "../../../../context/AuthContext";
import { useModal } from "../../../../context/ModalContext";
import { signInUpEnum } from "../../../../enumerations/signInUpEnum";
import styles from "./style.module.scss";

const Slogan = ({ showButton = true }) => {
  const { t } = useTranslation();
  const { openSignInUpModal } = useModal();
  const { isLogin } = useAuth();

  return (
    <div className={styles.slogan}>
      <div className={styles.mainSlogan}>{t("home.slogan")}</div>
      <div className={styles.subSlogan} dangerouslySetInnerHTML={{ __html: t("home.subSlogan") }} />
      {!isLogin && showButton && (
        <div className={styles.buttonGroup}>
          <CustomButton
            buttonStyle={`${styles.customButtonStyle}`}
            onClick={() => openSignInUpModal(signInUpEnum.SIGN_UP)}
          >
            {t("nav.signUp")}
          </CustomButton>
          <CustomButton
            buttonStyle={`${styles.customButtonStyle} ${styles.signIn}`}
            onClick={() => openSignInUpModal(signInUpEnum.SIGN_IN)}
          >
            {t("nav.signIn")}
          </CustomButton>
        </div>
      )}
    </div>
  );
};

export default Slogan;
